






























import { Component, Prop, Vue } from 'vue-property-decorator';
import * as Common from '@/tenant/common';

@Component
export default class SystemSideBar extends Vue {
  @Prop({default:false}) public langEnabled: boolean = false;
  public isPartner: boolean = false;
  
  public get isAdminSite():boolean {
    return this.$route.path.startsWith("admin");
  }
  public created() {
    // ライセンスによって表示項目を制御する
    this.langEnabled = this.$api.hasLicense(Common.licenseFlags.currency);
    this.isPartner = this.$api.isPartner;
  }
}
